import { activationValueText } from "./roofingV2QualificationView";

const NOT_CONFIGURED = "not configured";

function readField(source, key) {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return NOT_CONFIGURED;
  }
  if (!Object.prototype.hasOwnProperty.call(source, key) || source[key] == null) {
    return NOT_CONFIGURED;
  }
  return source[key];
}

function limitsView(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return { status: NOT_CONFIGURED, limits: [] };
  }
  return {
    status: null,
    limits: Object.keys(value).map((key) => ({
      key,
      value: typeof value[key] === "number" && Number.isFinite(value[key])
        ? value[key]
        : NOT_CONFIGURED,
    })),
  };
}

export function roofingV2MediaView(settings) {
  const media = settings && settings.media;
  const limits = limitsView(media && media.accepted_media_limits);
  const reviewedWaiverPermissions = readField(media, "reviewed_waiver_permissions");
  return {
    limitsStatus: limits.status,
    limits: limits.limits,
    reviewedWaiverPermissions: reviewedWaiverPermissions === "" ? '""' : reviewedWaiverPermissions,
    weatherPolicy: activationValueText(readField(media, "weather_policy")),
  };
}
